import api from './api';

export interface Empresa {
  id: string;
  social_name: string;
  trade_name?: string | null;
  cnpj: string;
  address?: string | null;
  number?: string | null;
  complement?: string | null;
  neighborhood?: string | null;
  city?: string | null;
  state?: string | null;
  zip_code?: string | null;
  phone?: string | null;
  email?: string | null;
  is_active: boolean;
  has_sped: boolean;
  has_dfe: boolean;
  logo?: string | null;
  menu_position?: string | null;
  licenca_ativa: boolean;
  data_vencimento_licenca?: string | null;
  valor_mensalidade?: number | null;
  observacoes_licenca?: string | null;
}

export type EmpresaInput = Partial<Omit<Empresa, 'id'>>;

const ENDPOINT = '/empresas';

const empresaService = {
  async listar(): Promise<Empresa[]> {
    const response = await api.get<Empresa[]>(ENDPOINT);
    return response.data;
  },
  async buscarPorId(id: string): Promise<Empresa> {
    const response = await api.get<Empresa>(`${ENDPOINT}/${id}`);
    return response.data;
  },
  async criar(data: EmpresaInput): Promise<Empresa> {
    const response = await api.post<Empresa>(ENDPOINT, data);
    return response.data;
  },
  async atualizar(id: string, data: EmpresaInput): Promise<Empresa> {
    const response = await api.put<Empresa>(`${ENDPOINT}/${id}`, data);
    return response.data;
  },
  async excluir(id: string): Promise<void> {
    await api.delete(`${ENDPOINT}/${id}`);
  },
  async ativarLicenca(id: string, data: { data_vencimento?: string; valor_mensalidade?: number; observacoes?: string }): Promise<{ message: string }> {
    const response = await api.post(`${ENDPOINT}/${id}/ativar_licenca`, data);
    return response.data;
  },
  async desativarLicenca(id: string, data: { motivo?: string }): Promise<{ message: string }> {
    const response = await api.post(`${ENDPOINT}/${id}/desativar_licenca`, data);
    return response.data;
  },
  async historicoPagamentos(id: string): Promise<import('./historicoPagamento').HistoricoPagamento[]> {
    const response = await api.get(`${ENDPOINT}/${id}/historico_pagamentos`);
    return response.data;
  },
};

export default empresaService;
